import firebase from 'firebase/app';
export const db = () => firebase.firestore();
